module.exports = __webpack_public_path__ + "static/img/noData.73684668.png";